import { CharacterItem, CharacterItemId, CharacterItemType } from "./CharacterItem";
import bucket from "../../../assets/images/characters/items/bucket.png";
import handMicrophone from "../../../assets/images/characters/items/hand-microphone.png";
import handMaraca from "../../../assets/images/characters/items/hand-maraca.png";
import faceGreenGlasses from "../../../assets/images/characters/items/green-glasses.png";
import wellies from "../../../assets/images/characters/items/wellies.png";
import blueHat from "../../../assets/images/characters/items/blue-hat.png";
import brownHat from "../../../assets/images/characters/items/brown-hat.png";
import longHat from "../../../assets/images/characters/items/long-hat.png";
import crownHat from "../../../assets/images/characters/items/crown.png";
import heartShades from "../../../assets/images/characters/items/glasses-heart.png";
import blueGlasses from "../../../assets/images/characters/items/glasses-blue.png";
import flag from "../../../assets/images/characters/items/flag.png";
import badge from "../../../assets/images/characters/items/badge.png";
import snorkle from "../../../assets/images/characters/items/snorkle.png";
import redBaloon from "../../../assets/images/characters/items/baloon-red.png";
import greenBaloon from "../../../assets/images/characters/items/baloon-green.png";
import flowerHat from "../../../assets/images/characters/items/hatFlower.png";
import headGreen from "../../../assets/images/characters/items/headGreen.png";
import headRed from "../../../assets/images/characters/items/headHearts.png";
import icecream from "../../../assets/images/characters/items/icecream.png";

export class BaseCharacter 
{
    private static _characterItems: Array<CharacterItem> = [
        new CharacterItem(CharacterItemId.Bucket, CharacterItemType.Head, [], bucket),
        new CharacterItem(CharacterItemId.HandMicrophone, CharacterItemType.HandHeld, [], handMicrophone),
        new CharacterItem(CharacterItemId.HandMaraca, CharacterItemType.HandHeld, [], handMaraca),
        new CharacterItem(CharacterItemId.FaceGreenGlasses, CharacterItemType.Face, [], faceGreenGlasses),
        // new CharacterItem(CharacterItemId.Wellies, CharacterItemType.Body, [], wellies),
        new CharacterItem(CharacterItemId.BlueHat, CharacterItemType.Head, [], blueHat),
        new CharacterItem(CharacterItemId.BrownHat, CharacterItemType.Head, [], brownHat),
        new CharacterItem(CharacterItemId.LongHat, CharacterItemType.Head, [], longHat),
        // new CharacterItem(CharacterItemId.Crown, CharacterItemType.Head, [], crownHat),
        new CharacterItem(CharacterItemId.HandFlag, CharacterItemType.HandHeld, [], flag),
        new CharacterItem(CharacterItemId.BodyBadge, CharacterItemType.Body, [], badge),
        new CharacterItem(CharacterItemId.HeartGlasses, CharacterItemType.Face, [], heartShades),
        new CharacterItem(CharacterItemId.GradientGlasses, CharacterItemType.Face, [], blueGlasses),
        new CharacterItem(CharacterItemId.Snorkel, CharacterItemType.Face, [], snorkle),
        new CharacterItem(CharacterItemId.HandRedBaloon, CharacterItemType.HandHeld, [], redBaloon),
        new CharacterItem(CharacterItemId.HandGreenBaloon, CharacterItemType.HandHeld, [], greenBaloon),
        // new CharacterItem(CharacterItemId.FlowerHat, CharacterItemType.Head, [], flowerHat),
        new CharacterItem(CharacterItemId.HatGreenEyes, CharacterItemType.Head, [], headGreen),
        new CharacterItem(CharacterItemId.HatHearts, CharacterItemType.Head, [], headRed),
        new CharacterItem(CharacterItemId.handIceCream, CharacterItemType.HandHeld, [], icecream),
        new CharacterItem(CharacterItemId.BaseHand, CharacterItemType.HandHeld, [], "", true),
    ];

    public static get items(): Array<CharacterItem> { return this._characterItems; }
}